import { createContext, useContext, useRef } from 'react'

interface IOnboardingContext {
  showOnboarding: React.MutableRefObject<boolean>
  setShowOnboarding: (value: boolean) => void
}

const OnboardingContext = createContext<IOnboardingContext | null>(null)

export const OnboardingContextProvider = ({ children }: React.PropsWithChildren) => {
  const showOnboarding = useRef(true)

  const setShowOnboarding = (value: boolean) => {
    showOnboarding.current = value
  }

  return (
    <OnboardingContext.Provider value={{ showOnboarding, setShowOnboarding }}>
      {children}
    </OnboardingContext.Provider>
  )
}

export const useOnboarding = () => {
  const context = useContext(OnboardingContext)

  return context
}
